import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { exportToCSV, exportToExcel, exportToPDF, ExportColumn } from '../utils/exportTable';

interface Props {
  filename?: string;
  title?: string;
  columns: ExportColumn[];
  rows: any[];
  size?: 'small' | 'middle' | 'large';
}

const getBranding = () => {
  let companyName = 'Nexus HR';
  try { companyName = localStorage.getItem('hr_company') || companyName; } catch (e) {}
  return { companyName, logoUrl: '/logo192.png', primaryColor: '#1A56DB', secondaryColor: '#059669' };
};

const ExportButtons: React.FC<Props> = ({ filename = 'export', title, columns, rows, size = 'middle' }) => {
  const disabled = !rows || rows.length === 0;
  const items = [
    { key: 'csv', label: 'CSV', onClick: () => exportToCSV(filename, columns, rows) },
    { key: 'excel', label: 'Excel', onClick: () => exportToExcel(filename, columns, rows) },
    { key: 'pdf', label: 'PDF (branded)', onClick: () => { exportToPDF(filename, title || filename, columns, rows, getBranding()); } },
  ];
  return (
    <Dropdown menu={{ items }} disabled={disabled} trigger={['click']}>
      <Button icon={<DownloadOutlined />} size={size}>Export</Button>
    </Dropdown>
  );
};

export default ExportButtons;
